import { CheckIcon, EyeIcon, EyeSlashIcon, FaceFrownIcon, FaceSmileIcon, TrashIcon, XMarkIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import {GreetingOccasionImage} from "../../../../models";
import clsx from "clsx";
import { deleteGreetingOccasionImage, setIsActive } from "../actions";
import { useActionState, useEffect } from "react";
import toast from "react-hot-toast";
 

export function IsActiveButton({image,onSuccess}:{image:GreetingOccasionImage,onSuccess:(image:GreetingOccasionImage)=>void}){
    const setIsActiveWithId = setIsActive.bind(null, image.id||0);
    const [state, formAction, isPending] = useActionState(setIsActiveWithId, {
        message: null,
        success: false,
        errors: {},
    });
    useEffect(()=>{
        if(state.success){            
            toast.success(state.message);
            image.isActive = !image.isActive;
            onSuccess(image);
        }
    },[state]);
    return (
        <form action={formAction}>
            <input type="hidden" name="isActive" value={image.isActive?"true":"false"} />
        <IconButton loading={isPending} label="IsActive" icon={image.isActive? EyeIcon:EyeSlashIcon}
        className={clsx(
            image.isActive? "text-green-500": "text-red-500"
        )}
        />
        </form>
    )
}
export function DeleteButton({image,onSuccess}:{image:GreetingOccasionImage,onSuccess:(image:GreetingOccasionImage)=>void}){
    const deleteWithId = deleteGreetingOccasionImage.bind(null, image.id||0);
    const [state, formAction, isPending] = useActionState(deleteWithId, {
        message: null,
        success: false,
        errors: {},
    });
    useEffect(()=>{
        if(state.success){
            toast.success(state.message);
            onSuccess(image);
        }
    },[state]);
    return (
        <form action={formAction}>
            <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
        </form>        
    )
}